var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsPageBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 699,
    height: 580,
    viewBox: "0 0 699 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.139 579.415L82.1714 233.126L-286.341 409.705L-67.55 94.1229L-432.583 -121.651L61.7999 -30.0721L134.65 -312.736L217.384 -53.173L574.35 -168.923L322.327 36.2348L698.618 164.039L326.28 176.259L480.816 423.286L240.632 254.594L111.139 579.415Z",
    fill: "url(#paint0_linear_376_2571)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_2571",
    x1: 675.814,
    y1: 157.248,
    x2: -130.809,
    y2: -150.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#115EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#115EF3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsPageBg);
export default __webpack_public_path__ + "static/media/contacts-page-bg.aa7872b8a55f66619615c047375f9584.svg";
export { ForwardRef as ReactComponent };